import { transformPropOrder } from '../../render/utils/keys-transform.mjs';
var translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};

function buildTransform(state) {
  var transform = "";
  var transformIsDefault = true;
  /**
   * Loop over all possible transforms in order, adding the ones that
   * are present to the transform string.
   */

  for (var i = 0; i < transformPropOrder.length; i++) {
    var key = transformPropOrder[i];
    var value = state.latest[key];
    if (value === undefined) continue;
    var valueIsDefault = true;

    if (typeof value === "number") {
      valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
    } else {
      valueIsDefault = parseFloat(value) === 0;
    }

    if (!valueIsDefault) {
      transformIsDefault = false;
      var transformName = translateAlias[key] || key;
      var valueToRender = state.latest[key];
      transform += "".concat(transformName, "(").concat(valueToRender, ") ");
    }
  }

  return transformIsDefault ? "none" : transform.trim();
}

export { buildTransform };